import { createEntityAdapter } from '@reduxjs/toolkit';

export const resourcesAdapter = createEntityAdapter();
export const resourcesWithTaxNumberStatusAdapter = createEntityAdapter();
export const resourcesToMakeAdminOfAdapter = createEntityAdapter();
export const loggedInUserResourcesAdapter = createEntityAdapter();

export const {
  selectAll: selectAllResources,
  selectEntities: selectResourceEntities,
  selectById: selectResourceById,
  selectIds: selectResourceIds,
} = resourcesAdapter.getSelectors((state) => state.resources.resources);
export const {
  selectAll: selectAllResourcesWithTaxNumberStatus,
  selectEntities: selectResourcesWithTaxNumberStatusEntities,
  selectById: selectResourceWithTaxNumberStatusById,
  selectIds: selectResourcesWithTaxNumberStatusIds,
} = resourcesWithTaxNumberStatusAdapter.getSelectors(
  (state) => state.resources.resourcesWithTaxNumberStatus
);
export const {
  selectAll: selectAllResourcesToMakeAdminOf,
  selectEntities: selectResourcesToMakeAdminOfEntities,
  selectById: selectResourcesToMakeAdminOfById,
  selectIds: selectResourcesToMakeAdminOfIds,
} = resourcesToMakeAdminOfAdapter.getSelectors(
  (state) => state.resources.resourcesToMakeAdminOf
);
